<template>
  <v-dialog v-model="isOpen" max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">Configuración del Árbol</span>
      </v-card-title>
      <v-card-text>
        <v-text-field
          label="Número máximo de niveles"
          v-model.number="maxLevels"
          type="number"
          min="1"
          required
        />
        <v-text-field
          label="Número máximo de hijos por rama"
          v-model.number="maxChildren"
          type="number"
          min="1"
          required
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="submitConfig">Guardar</v-btn>
        <v-btn text @click="closeModal">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: Boolean
  },
  data () {
    return {
      maxLevels: {}, // Valor por defecto
      maxChildren: {} // Valor por defecto
    }
  },
  methods: {
    submitConfig () {
      this.$emit('config-set', { maxLevels: this.maxLevels, maxChildren: this.maxChildren })
      this.closeModal()
    },
    closeModal () {
      this.$emit('update:isOpen', false)
    }
  }
}
</script>
